export default __webpack_public_path__ + "static/media/rectangle-orange.fe37db51.svg";